"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberOfTagChildrenCannotBeAlteredError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when try to update a tag to have a different number of children
 */
class NumberOfTagChildrenCannotBeAlteredError extends client_library_1.ExtendableError {
    constructor() {
        super(`Number of tag children cannot be altered`);
    }
}
exports.NumberOfTagChildrenCannotBeAlteredError = NumberOfTagChildrenCannotBeAlteredError;
//# sourceMappingURL=NumberOfTagChildrenCannotBeAlteredError.js.map